document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("toggle-button");
  const currentTextEl = document.querySelector(".current-text");
  const nextTextEl = document.querySelector(".next-text");

  let isToggled = false;
  let animationInProgress = false; // prevent multiple clicks during animation

  toggleButton.addEventListener("click", () => {
    if (animationInProgress) return; // avoid overlapping clicks
    animationInProgress = true;

    const fromEl = isToggled ? nextTextEl : currentTextEl;
    const toEl = isToggled ? currentTextEl : nextTextEl;

    // First prepare hidden incoming element on right
    gsap.set(toEl, { opacity: 0, x: 50 });
    toEl.style.pointerEvents = "none";
    fromEl.style.pointerEvents = "none";

    const timeline = gsap.timeline({
      onComplete: () => {
        isToggled = !isToggled;
        animationInProgress = false;

        // Update visibility to only have one element accessible
        gsap.set(fromEl, { opacity: 0 });
        gsap.set(toEl, { opacity: 1, x: 0 });
        toEl.style.pointerEvents = "";
      },
    });

    // Animate old element OUT (left)
    timeline.to(fromEl, {
      x: -50,
      opacity: 0,
      duration: 0.6,
      ease: "power2.in",
    });

    // Animate new element IN (from right)
    timeline.to(
      toEl,
      {
        x: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
      },
      "-=0.3"
    ); // slight overlap clearly to make smoother
  });
});
